import {writable} from 'svelte/store';
import {ApplicationData} from "../models/ApplicationData";
import {QuestionPage} from "../models/QuestionPage";
import {SuspectedCondition} from "../models/SuspectedCondition";
import {QuestionAnswer} from "../models/QuestionAnswer";
import {QuestionAnswerData} from "../models/QuestionAnswerData";
import {NavigationState} from "../models/NavigationState";
const isElectronicConsentCompleted = localStorage.getItem("ElectronicConsent");
export const ElectronicConsent = writable(isElectronicConsentCompleted);
ElectronicConsent.subscribe(value => {
    localStorage.setItem("ElectronicConsent", value === 'true' ? 'true' : 'false');
});

const testApplicationId = sessionStorage.getItem("ApplicationId");
export const ApplicationId = writable(testApplicationId);
ApplicationId.subscribe(value => {
    localStorage.setItem("ApplicationId", value || '' );
});

const AuthToken = String();
export const StoredAuthToken = writable(AuthToken);

export function SetAuthToken(authToken: string){
   StoredAuthToken.set(authToken);
}

const applicationData = new ApplicationData();
export const StoredApplicationData = writable(applicationData);


const applicationDataList: ApplicationData[] = [];
export const StoredApplicationDataList = writable(applicationDataList);

const baseApplicationData = new ApplicationData();
export const BaseApplicationData = writable(baseApplicationData);

let questionPages: QuestionPage[] = [];
export const StoredMedicalQuestions = writable(questionPages);

let disclosures: String[] = [];
export const Disclosures = writable(disclosures);

let ezAppBaseUrl: String = '';
export const EzAppBaseUrl = writable(ezAppBaseUrl);

let caseId: number = 0;
export const CaseId = writable(caseId);

let suspectedConditions: SuspectedCondition[] = [];
export const SuspectedConditions = writable(suspectedConditions);

let questionAnswers: QuestionAnswer[] = [];
export const QuestionAnswers = writable(questionAnswers);

let questionAnswerData = new QuestionAnswerData(0, -1);
export const QuestionAnswerMeta = writable(questionAnswerData);

let honestyStatementChecked: boolean = false;
export const HonestyStatementChecked = writable(honestyStatementChecked);

let navigationState = new NavigationState();
export const NavigationStateStore = writable(navigationState);

let fatalError: Boolean = false;
export const FatalError = writable(fatalError);

let incidentalError: Boolean = false;
export const IncidentalError = writable(incidentalError);


export function saveApplicationData(applicationData: ApplicationData): void  {
    StoredApplicationData.set(applicationData);
}

